import parseGroupSettings from "../../utilities/logbook/parseGroupSettings";
import { mapQuery } from "../../utilities/query/mapQuery";
import { useGroupByName } from "../groups/useGroupByName";

/**
 * Returns the {@link AccessLogbookSettings} for the current database.
 * @returns - The {@link AccessLogbookSettings} for the current database.
 */
export function useLogbookSettings() {
  return mapQuery(useGroupByName("Access Logbook"), group => parseGroupSettings(group));
}
